<template>
  <div class="chip" :style="{ background: color }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Chip',
  props: {
    color: { type: String, default: '#b5c3bc' },
  },
};
</script>

<style lang="scss" scoped>
.chip {
  border-radius: 25px;
  color: #11291b;
  font-size: 18px;
  margin-left: 5px;
  margin-right: 5px;
  min-width: 156px;
  padding: 8px 5px 6px 5px;
  text-align: center;
}
</style>
